import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import enviro from 'enviro';

// @ts-expect-error feedback-loader is untyped - no plans to type it in the near future
import { useFeedbackLoader } from 'feedback-loader/useFeedbackLoader';
const ClonerFeedbackSurvey = () => {
  const history = useHistory();
  const location = useLocation();
  const isProd = enviro.isProd();
  const {
    loadSurvey,
    clientLoaded
  } = useFeedbackLoader();
  const CLONER_FEEDBACK_SURVEY_ID = 1329;
  useEffect(() => {
    if (isProd && clientLoaded) {
      loadSurvey(CLONER_FEEDBACK_SURVEY_ID, 'CSAT');
    }
    const searchParams = new URLSearchParams(location.search);
    const isClonedRecord = searchParams.get('isClonedRecord') === 'true';
    if (isClonedRecord) {
      searchParams.delete('isClonedRecord');
      history.replace({
        pathname: location.pathname,
        search: searchParams.toString() ? `?${searchParams.toString()}` : ''
      });
    }
  }, [clientLoaded, loadSurvey, isProd, history, location]);
  return null;
};
export default ClonerFeedbackSurvey;